import { useNavigate } from 'react-router-dom';
import { Brain } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="text-center">
        <Brain className="w-16 h-16 text-teal/30 mx-auto mb-6" strokeWidth={1.2} />
        <h1 className="text-6xl font-heading font-bold text-white mb-2">404</h1>
        <p className="text-gray-400 text-lg mb-8">
          This page doesn't exist.
        </p>
        <button
          onClick={() => navigate('/')}
          className="btn-gold"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
